interface AppIconProps {
  src: string;
  alt: string;
  className?: string;
}

export function AppIcon({ src, alt, className = "" }: AppIconProps) {
  return (
    <img
      src={src}
      alt={alt}
      className={`aspect-square shrink-0 rounded-[22%] border border-black/10 object-cover ${className}`}
    />
  );
}